export default function PricingSectionEn() {
  const handleLineBooking = () => {
    window.open('https://line.me/ti/p/~yokota0809', '_blank');
  };

  const plans = [
    {
      duration: '2 Hours',
      price: '¥15,000',
      features: [
        'Airport pick-up/drop-off',
        'Short distance support',
        'Basic navigation help',
        'Parking assistance'
      ],
      popular: false
    },
    {
      duration: 'Half Day',
      subtitle: '4 Hours',
      price: '¥30,000',
      features: [
        'Multiple destination support',
        'Sightseeing assistance',
        'Restaurant recommendations',
        'Full navigation support',
        'Parking & highway guidance'
      ],
      popular: true
    },
    {
      duration: 'Full Day',
      subtitle: '8 Hours',
      price: '¥50,000',
      features: [
        'All-day comprehensive support',
        'Flexible itinerary',
        'Tokyo area coverage',
        'Local insider guidance',
        'Complete driving assistance',
        'Photo spot recommendations'
      ],
      popular: false
    }
  ];

  return (
    <section className="py-24 bg-zinc-900">
      <div className="max-w-7xl mx-auto px-6">
        {/* Section Header */}
        <div className="text-center mb-16">
          <h2 className="text-4xl md:text-5xl font-bold text-white mb-6">
            Service <span className="text-amber-400">Pricing</span>
          </h2>
          <p className="text-xl text-gray-400 max-w-3xl mx-auto mb-8">
            Transparent pricing with no hidden fees
          </p>
        </div>

        {/* Pricing Cards */}
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8 mb-16">
          {plans.map((plan, index) => (
            <div
              key={index}
              className={`relative bg-zinc-800/50 backdrop-blur-sm rounded-3xl p-8 ${
                plan.popular
                  ? 'border-2 border-amber-500 shadow-2xl shadow-amber-500/20 transform scale-105'
                  : 'border border-zinc-700'
              }`}
            >
              {plan.popular && (
                <div className="absolute -top-4 left-1/2 -translate-x-1/2">
                  <span className="bg-gradient-to-r from-amber-500 to-amber-600 text-black font-bold px-6 py-2 rounded-full text-sm whitespace-nowrap">
                    Most Popular
                  </span>
                </div>
              )}

              <div className="text-center mb-8">
                <h3 className="text-3xl font-bold text-white mb-2">{plan.duration}</h3>
                {plan.subtitle && (
                  <p className="text-gray-400 text-sm mb-4">{plan.subtitle}</p>
                )}
                <div className="text-5xl font-bold text-amber-400 mb-2">{plan.price}</div>
                <p className="text-gray-500 text-sm">per session</p>
              </div>

              <ul className="space-y-4 mb-8">
                {plan.features.map((feature, idx) => (
                  <li key={idx} className="flex items-start gap-3">
                    <i className="ri-check-line text-amber-400 text-xl flex-shrink-0 mt-0.5"></i>
                    <span className="text-gray-300">{feature}</span>
                  </li>
                ))}
              </ul>

              <button
                onClick={handleLineBooking}
                className={`w-full py-4 rounded-xl font-bold transition-all duration-300 whitespace-nowrap ${
                  plan.popular
                    ? 'bg-gradient-to-r from-amber-500 to-amber-600 hover:from-amber-600 hover:to-amber-700 text-black'
                    : 'bg-zinc-700 hover:bg-zinc-600 text-white'
                }`}
              >
                Book via LINE
              </button>
            </div>
          ))}
        </div>

        {/* Extension Fee */}
        <div className="max-w-4xl mx-auto bg-zinc-800/50 border border-amber-500/30 rounded-2xl p-8">
          <div className="flex flex-col md:flex-row items-center justify-between gap-6">
            <div className="flex items-center gap-4">
              <div className="w-16 h-16 bg-amber-500/20 rounded-xl flex items-center justify-center flex-shrink-0">
                <i className="ri-time-line text-amber-400 text-3xl"></i>
              </div>
              <div>
                <h3 className="text-2xl font-bold text-white mb-2">Extension Fee</h3>
                <p className="text-gray-400">Additional time beyond your booked plan</p>
              </div>
            </div>
            <div className="text-center md:text-right">
              <div className="text-4xl font-bold text-amber-400 mb-1">¥8,000</div>
              <p className="text-gray-400 text-sm">per hour</p>
            </div>
          </div>
        </div>

        {/* CTA */}
        <div className="text-center mt-16">
          <button
            onClick={handleLineBooking}
            className="inline-flex items-center gap-3 bg-gradient-to-r from-amber-500 to-amber-600 hover:from-amber-600 hover:to-amber-700 text-black font-bold px-12 py-6 rounded-full text-xl transition-all duration-300 shadow-xl hover:shadow-2xl hover:scale-105 whitespace-nowrap"
          >
            <i className="ri-line-fill text-3xl"></i>
            Book Now via LINE
          </button>
          <p className="text-gray-400 mt-6">Quick response within 24 hours</p>
        </div>
      </div>
    </section>
  );
}